import { $ } from '@/libs/jquery/index'

export class Tabs {
  private selectors: ISelectors = {
    elem: '[data-selector="tabsLinks"]',
    hideElems: '[data-selector="tabsLinksHide"]',
  }
  private classes: IClasses = {
    active: 'is-active',
    elem: 'tabsLinks__link',
    more: 'tabsLinks__link--more',
  }
  private tabLinks: JQuery
  private elements: string

  constructor() {
    this.elements = `.${this.classes.elem}, ${this.selectors.elem}`
    this.tabLinks = $(this.elements)

    if (this.tabLinks.length) {
      this.init()
    }
  }

  private init(): void {
    this.hideTabsOnStart()
    this.showTabOnClick()
  }

  private hideTabsOnStart(): void {
    this.tabLinks.each((index: number, element: HTMLElement) => {
      const tab = $(element)
      const tabContentID = tab.attr('href')
      const isTabActive  = tab.hasClass(this.classes.active)

      if (!isTabActive) {
        $(tabContentID).addClass('hidden')
      } else {
        $(tabContentID).removeClass('hidden')
      }
    })
  }

  private showTabOnClick(): void {
    $('body')
      .off('click', this.elements)
      .on('click', this.elements, (e) => {
        e.preventDefault()
        const tab = $(e.currentTarget)

        if (tab.hasClass(this.classes.more)) {
          tab.siblings(this.selectors.hideElems).fadeToggle(250)

          return false
        }

        const isTabActive = tab.hasClass(this.classes.active)
        const isSlide: boolean = tab.data('mode') ? tab.data('mode') === 'slide' : false

        if (isTabActive) {
          const tabContentID = tab.attr('href')
          this.isOpenTab($(tabContentID), isSlide)
          tab.removeClass(this.classes.active)
        } else {
          const closestTabLinks = this.closestTabLinks(e)

          if (closestTabLinks) {
            this.disableAllTabLinksWithSameLevel(closestTabLinks)
            this.toggleActivityForTabLink(tab)
            this.reArrangeTabOnClick(closestTabLinks)
          }
        }
      })
  }

  private closestTabLinks(e: JQuery.ClickEvent): JQuery | null {
    try {
      return $(`[data-tab-level='${ e.currentTarget.dataset.tabLevel }']`)
    } catch {
      return null
    }
  }

  private disableAllTabLinksWithSameLevel(tabs: JQuery): void {
    tabs.removeClass(this.classes.active)
  }

  private toggleActivityForTabLink(tab: JQuery) {
    tab.addClass(this.classes.active)
  }

  private reArrangeTabOnClick(tabLinks: JQuery): void {
    tabLinks.each((index: number, element: HTMLElement) => {
      const tab = $(element)
      const tabContentID = tab.attr('href')
      const isTabActive = tab.hasClass(this.classes.active)
      const isSlide: boolean = tab.data('mode') ? tab.data('mode') === 'slide' : false

      if (!isTabActive) {
        this.isOpenTab($(tabContentID), isSlide)
      } else {
        if (isSlide) {
          $(tabContentID).slideDown()
        } else {
          $(tabContentID).removeClass('hidden')
        }
      }
    })
  }

  private isOpenTab(tab: JQuery, isSlide: boolean): void {
    if (isSlide) {
      tab.slideUp()
    } else {
      tab.addClass('hidden')
    }
  }
}
